import { atom } from 'jotai';

const showDealerNumberPdpAtom = atom<boolean>(false);

export { showDealerNumberPdpAtom };
